import { useAppDispatch } from "@/services/store";
import type { UseFilters } from "@/features/notes-manager";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import { notesContentActions } from "../slice";

export const useFilters = (): UseFilters => {
  const dispatch = useAppDispatch();

  const setSorter = (sort: MenuSorterOptions) => {
    dispatch(notesContentActions.setSorter(sort));
  };

  const setTitleFilter = (value: string) => {
    dispatch(notesContentActions.setTitleFilter(value));
  };

  const setNoteTitleFilter = (value: string) => {
    dispatch(notesContentActions.setNoteTitleFilter(value));
  };

  const setFromDateFilter = (value: string) => {
    dispatch(notesContentActions.setFromDateFilter(value));
  };

  const setToDateFilter = (value: string) => {
    dispatch(notesContentActions.setToDateFilter(value));
  };

  const setPersonGroupFilters = (value: string[]) => {
    dispatch(notesContentActions.setPersonGroupFilters(value));
  };

  const setNoteTypeFilters = (value: string[]) => {
    dispatch(notesContentActions.setNoteTypeFilters(value));
  };

  const setStringFilter = (value: string) => {
    dispatch(notesContentActions.setStringFilter(value));
  };

  return {
    setSorter,
    setTitleFilter,
    setNoteTitleFilter,
    setFromDateFilter,
    setToDateFilter,
    setPersonGroupFilters,
    setNoteTypeFilters,
    setStringFilter,
  };
};
